module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/HN-e05ce564a05e58907148e16f04d8dea7.png";